import {
    CardEntity,
} from "@dropDesk/domain/entities/payment_method/payment_method.entity";
import {
    ContentButtonPay,
    ContainerCreditCardSaved, ContentInfoCard, ContentInfoHolder, ContainerInfoCreditCard,
} from "@dropDesk/presentation/pages/subscription/ui/checkout/payment_type/payment_method/credit_card/styled";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Text, TextBold} from "@dropDesk/presentation/pages/subscription/ui/checkout/payment_type/payment_method/styled";
import ButtonPay
    from "@dropDesk/presentation/pages/subscription/ui/checkout/payment_type/payment_method/credit_card/credit_card_saved/button_pay";

const CreditCardSaved = (
    {
        cardSaved,
        loading,
        onClickPayCreditCardSaved,
        isEditExternal,
        isTrial,
    }: {
        cardSaved: CardEntity
        loading: boolean
        onClickPayCreditCardSaved: () => void
        isEditExternal?: boolean
        isTrial?: boolean
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <ContainerCreditCardSaved bordercolor={colors.text}>
            <ContentInfoCard>
                <TextBold size={12} color={colors.text}>
                    Dados do cartão salvo:
                </TextBold>
                <ContentInfoHolder>
                    <ContainerInfoCreditCard>
                        <Text size={12} color={colors.hint}>
                            Número do cartão
                        </Text>
                        <TextBold size={13}
                              color={colors.text}>{cardSaved.displayNumber}</TextBold>
                    </ContainerInfoCreditCard>
                    <ContainerInfoCreditCard>
                        <Text size={12} color={colors.hint}>
                            Vencimento
                        </Text>
                        <TextBold size={13} color={colors.text}>{cardSaved.expirationDate}</TextBold>
                    </ContainerInfoCreditCard>
                    <ContainerInfoCreditCard>
                        <Text size={12} color={colors.hint}>
                            Bandeira
                        </Text>
                        <TextBold size={13}
                              color={colors.text}>{cardSaved.brand?.toUpperCase() ?? ''}</TextBold>
                    </ContainerInfoCreditCard>
                </ContentInfoHolder>
            </ContentInfoCard>
            {!isEditExternal &&
                <ContentButtonPay>
                    <ButtonPay
                        loading={loading}
                        onClickPayCreditCardSaved={onClickPayCreditCardSaved}
                        isTrial={isTrial}
                    />
                </ContentButtonPay>}
        </ContainerCreditCardSaved>
    );
}
export default CreditCardSaved;
